import {
  CATEGORY_SETTINGS_REQUEST,
  CATEGORY_SETTINGS_FAILURE,
  FETCH_CATEGORY_SETTINGS_SUCCESS,
  CREATE_CATEGORY_SETTING_SUCCESS,
  UPDATE_CATEGORY_SETTING_SUCCESS,
  DELETE_CATEGORY_SETTING_SUCCESS,
} from "../action/types";

const initialState = {
  categories: [],
  loading: false,
  error: null,
};

const categorySettingsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case CATEGORY_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CATEGORY_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload)
            ? payload
            : [],
      };

    case CREATE_CATEGORY_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: [...state.categories, payload],
      };

    case UPDATE_CATEGORY_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: state.categories.map((cat) =>
          cat.id === payload.id ? payload : cat,
        ),
      };

    case DELETE_CATEGORY_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: state.categories.filter((cat) => cat.id !== payload),
      };

    case CATEGORY_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default categorySettingsReducer;
